import { enforceTenantSession } from './tenant-session-guard';

// Side-effecting on purpose. Imported first in main.tsx so it runs before the
// auth store module is evaluated — zustand's persist middleware reads
// localStorage at import time, and a session cleared after that point would
// already be live in memory.
enforceTenantSession();
